






















































































































import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { IGame, IGameDescriptionAsset } from '~/store/games/types';

@Component({
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
})
export default class AboutThisGame extends Vue {
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];

  @Action('getItemsForSaleByGala', { namespace: 'games' })
  private getItemsForSaleByGala!: (gameItemProductsInput: {
    game?: string;
    baseId?: string;
    topItems?: number;
  }) => void;

  @Prop() gameName!: string;

  showFullSize = false;
  activeAsset: IGameDescriptionAsset | null = null;
  gameSlideshowSettings = {
    itemsToShow: 2,
    infiniteScroll: true,
    wheelControl: false,
    // autoPlay: true,
    playSpeed: 5000,
    breakpoints: {
      600: {
        itemsToShow: 3,
      },
      1000: {
        itemsToShow: 4,
      },
    },
  };

  get game() {
    return this.games.find(game => game.name === this.gameName);
  }

  showImageDialog(image: IGameDescriptionAsset) {
    this.activeAsset = image;
    this.showFullSize = true;
  }
}
